import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

export default {
  install: (Vue, { router }) => {
    // 初始化sentry
    let tracingOrigins = [window.location.host, /^\//]
    Sentry.init({
      Vue,
      release: `hfq-lp-server`,
      dsn: process.env.VUE_APP_SENTRY_DSN, // 线上地址
      integrations: [
        new Integrations.BrowserTracing({
          // 文档地址 https://docs.sentry.io/platforms/javascript/guides/vue/performance/instrumentation/automatic-instrumentation/
          routingInstrumentation: Sentry.vueRouterInstrumentation(router),
          tracingOrigins,
          beforeNavigate: context => {
            return Object.assign({}, context, {name: 'Page ' + location.href})
          },
          shouldCreateSpanForRequest: url => {
            return !url.match(/\/health\/?$/);
          },
        }),
      ],
      tracesSampleRate: 0.1,
      sampleRate: 0.1,
    });
    console.log('sentry加载成功！');
  }
}
